import { render, staticRenderFns } from "./attention-empty.vue?vue&type=template&id=e30c62e6&scoped=true"
import script from "./attention-empty.vue?vue&type=script&lang=js"
export * from "./attention-empty.vue?vue&type=script&lang=js"
import style0 from "./attention-empty.vue?vue&type=style&index=0&id=e30c62e6&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e30c62e6",
  null
  
)

export default component.exports